import {t} from '@lingui/macro';

import {LocalizeRenderer} from '../../../srcCommon/internationalization/internationalizationContext';
import {Localizer} from '../../store/stateless/internationalizationSelectors';

export enum SettingsResourcesTableColumnsEnum {
  PATH = 'PATH',
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  AVAILABLE_IN = 'AVAILABLE_IN',
  LAST_USED = 'LAST_USED',
  DATE_CREATED = 'DATE_CREATED',
  TYPE = 'TYPE',
  ARCHIVED_DELETE = 'ARCHIVED_DELETE',
}

export function renderSettingsResourcesTableColumnName(
  col: SettingsResourcesTableColumnsEnum,
  localize: Localizer,
) {
  return columnNameRenderers[col](localize);
}

const columnNameRenderers: {[k in SettingsResourcesTableColumnsEnum]: LocalizeRenderer} = {
  [SettingsResourcesTableColumnsEnum.PATH]: (localize) => localize(t('settingstable-name')`Name`),
  [SettingsResourcesTableColumnsEnum.NAME]: (localize) => localize(t('settingstable-name')`Name`),
  [SettingsResourcesTableColumnsEnum.DESCRIPTION]: (localize) =>
    localize(t('settingstable-description')`Description`),
  [SettingsResourcesTableColumnsEnum.AVAILABLE_IN]: (localize) =>
    localize(t('settingstable-availablein')`Available in`),
  [SettingsResourcesTableColumnsEnum.LAST_USED]: (localize) =>
    localize(t('settingstable-lastused')`Last used`),
  [SettingsResourcesTableColumnsEnum.DATE_CREATED]: (localize) =>
    localize(t('settingstable-datecreated')`Date created`),
  [SettingsResourcesTableColumnsEnum.TYPE]: (localize) => localize(t('settingstable-type')`Type`),
  [SettingsResourcesTableColumnsEnum.ARCHIVED_DELETE]: () => '',
};
